import { useState, useEffect } from 'react';
import PageHeader from '../../components/PageHeader';
import { apiUrl } from '../../config/apiUrls';
import CreditPurchaseTable from '../../components/institute/component/credit-purchase-table';

const InstituteCredits = () => {
  const [creditsData, setCreditsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  const getCreditTransaction = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const userId = sessionStorage.getItem("id");
        
      if (!userId) {
        throw new Error("User ID is missing. Please log in again.");
      }

      const response = await fetch(apiUrl?.getCreditTransaction({userId}), {
        method: 'GET',
        headers: {
          'Authorization': API_TOKEN,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const response_data = await response.json();
      const apiData = response_data.data || [];
      setCreditsData(apiData)

    } catch (err) {
      console.log("err",err)
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getCreditTransaction();
  }, []);


  // Loading state
  if (isLoading) {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <PageHeader title="Credit Allocation" 
              breadcrumbs={[
                { label: "Dashboard", path: "/institute-dashboard" },
                { label: "Credit Allocation", active: true }
              ]}
            />
          </div>
        </div>
        
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </>
    );
  }

  console.log("creditsData",creditsData)

  return (
    <>
      <PageHeader
        title="License Allocation"
        breadcrumbs={[
          { label: "Dashboard", path: "/institute-dashboard" },
          { label: "License Allocation", active: true }
        ]}
      />

      {error && (
        <div className="row mb-3">
          <div className="col-12">
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
              <strong>Error:</strong> {error}
              <button type="button" className="btn-close" data-bs-dismiss="alert"></button>
            </div>
          </div>
        </div>
      )}

      <CreditPurchaseTable data={creditsData}/>
    </>
  );
};

export default InstituteCredits;